import type { Column } from 'react-table';
import type { Statistics } from 'feature-components/reports/item-assessment-report';
import {
  NationalPercentageCol,
  PercentageCorrectCol,
  QuestionCol,
  QuestionDescriptionCol,
  ScaleDifficultyCol
} from 'feature-components/reports/item-assessment-report/columns/common-columns';
import type { TestType } from 'services/assist-api/entities/test/tests';

export default function getReadingVocabularyColumns(
  canHaveStyledQuestionType: boolean,
  showReferenceData: boolean,
  testType: TestType | undefined
): Column<Statistics>[] {
  return [
    { ...QuestionCol({ canHaveStyledQuestionType, testType }), width: 80 },
    {
      Header: 'Word',
      id: 'word',
      accessor: (data) => data.metadatas?.find((meta) => meta.name.toLowerCase() === 'word').value,
      disableSortBy: true,
      width: 100
    },
    {
      ...QuestionDescriptionCol,
      id: 'description',
      Header: 'Contextual Sentence'
    },
    ScaleDifficultyCol,
    PercentageCorrectCol(showReferenceData),
    showReferenceData && NationalPercentageCol
  ].filter(Boolean);
}
